import { render, staticRenderFns } from "./CalendariosPostagens.vue?vue&type=template&id=686c474a"
import script from "./CalendariosPostagens.vue?vue&type=script&lang=js"
export * from "./CalendariosPostagens.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports